import { styled } from '@mui/material/styles';
import { Paper, LinearProgress } from '@mui/material';

export const MetricsRow = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '20px',
    marginBottom: '30px',

    '@media (max-width: 1024px)': {
        gridTemplateColumns: 'repeat(2, 1fr)',
    },

    '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
    },
});

export const MetricCard = styled(Paper)({
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
});

export const MetricTitle = styled('p')({
    margin: '0 0 5px 0',
    fontSize: '0.9rem',
    color: 'rgba(0, 0, 0, 0.6)',
});

export const MetricValue = styled('p')({
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 600,
    color: 'var(--primary-main)',
});

export const ProgressContainer = styled('div')({
    marginTop: '10px',
});

export const ProgressBar = styled(LinearProgress)({
    height: '6px',
    borderRadius: '3px',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',

    '& .MuiLinearProgress-bar': {
        backgroundColor: 'var(--secondary-main)',
    },
});

export const ProgressLabel = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '0.8rem',
    color: 'rgba(0, 0, 0, 0.5)',
    marginTop: '5px',
});

export const OverallStats = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    marginTop: '15px',

    '& > div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },

    '& .stat-value': {
        fontSize: '1.1rem',
        fontWeight: 600,
        color: 'var(--primary-main)',
    },

    '& .stat-label': {
        fontSize: '0.8rem',
        color: 'rgba(0, 0, 0, 0.6)',
    },
});

